import { GenericPage } from '@contember/admin'
import * as React from 'react'

export default () => {
	return <GenericPage title={true}>{null}</GenericPage>
}
